import { Controller } from "@hotwired/stimulus"

// QAN-480 (David's feedback): filter the Bank & product <select> as you type,
// instead of scrolling the whole lender list. Matches the typed text against
// each option's bank (optgroup label) + product text, hiding non-matches and
// collapsing empty groups. Leaves the native <select> in place so it stays
// accessible and still submits lender_id without JS.
export default class extends Controller {
  static targets = ["query", "select"]

  apply() {
    const term = this.queryTarget.value.trim().toLowerCase()

    this.selectTarget.querySelectorAll("optgroup").forEach((group) => {
      let anyVisible = false
      group.querySelectorAll("option").forEach((option) => {
        const haystack = `${group.label} ${option.text}`.toLowerCase()
        const match = term === "" || haystack.includes(term)
        option.hidden = !match
        if (match) anyVisible = true
      })
      group.hidden = !anyVisible
    })

    // If the current selection was filtered out, clear it so a stale hidden
    // value isn't submitted.
    const selected = this.selectTarget.selectedOptions[0]
    if (selected && selected.hidden) this.selectTarget.value = ""
  }
}
